import styled from "styled-components";

export const Message = styled.div`
  font-family: Nunito, sans-serif !important;
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px; /* vertical spacing */
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px; /* vertical spacing */
  border-radius: 8px;
  overflow: hidden;
`;

export const Button = styled.button`
  display: flex;
  width: 256px;
  height: 58px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 3px;
  background: #1d58e2;
  color: #fff;
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
`;

export const PageName = styled(Message)`
  font-size: 35px;
  font-weight: semi-bold;
  color: #4f4f4f;
`;

export const Title = styled(Message)`
  margin-bottom: 10px;
  font-size: 30px;
  font-weight: bold;
`;

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 11px;
  overflow: hidden;
`;

export const CompanyBarInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #e8e8e8;
  padding: 16px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center; /* vertical alignment */
`;

export const AddressContainer = styled.div`
  background: #d9d9d93d;
  padding: 16px;
`;

export const AddressRow = styled.div`
  align-items: center; /* vertical alignment */
  justify-content: space-between;
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 equal columns */
`;

export const AddressLabel = styled(Message)`
  color: #666;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const AddressValue = styled(Message)`
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const WebsiteEmailContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TaxIdContactContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BarFieldLabel = styled(Message)`
  color: #737373;
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const LinkText = styled.div`
  color: #1d58e2;
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse; 
  td, th {
    padding: 12px 16px; 
    text-align: left; 
  }
  border-radius: 6px;
  overflow: hidden;
`;

export const TableHeader = styled.thead`
  background: rgba(194, 194, 194, 0.24);
`;

export const TableHeaderLabel = styled.th`
  color: #303030;
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const TableBody = styled.tbody`
  background: #d9d9d93d;
`;

export const NameCell = styled.td`
  display: flex;
  align-items: center;
  color: #1D3784;
  font-family: Nunito;  
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const DesignationCell = styled.td`
  text-align: center;
  color: #000;
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const EmailCell = styled.td`
  text-align: center;
  color: #1d58e2;
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  justify-content: center;
`;

export const ContactNoCell = DesignationCell;

export const ContactActionsCell = styled.td`
  display: flex;
  flex-direction: row;
`;

export const ContactActions = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border: none;
  background: none;
  padding: 6px;
`;

export const SubscriptionContainer = styled.div`
  border-radius: 8px;
  overflow: hidden;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;

export const ProductPlanContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: rgba(194, 194, 194, 0.24);
  padding: 16px;
`;

export const ProductName = styled(Message)`
  color: #383838;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const BarFieldValue = styled(Message)`
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const ManageLicense = styled(Message)`
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const ManageLicenseContainer = styled.div`
  display: flex;
  flex-direction: row;
  background: #d9d9d93d;
  padding: 16px;
`;

export const LicenseContainer = styled.div`
  background: #d9d9d93d;
  padding: 16px;
  align-items: center; /* vertical alignment */
  justify-content: space-between;
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 equal columns */
`;

export const FieldLabelValueContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FieldLabel = styled(Message)`
  color: #737373;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const FieldValue = styled(Message)`
  color: #000;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
export const SubscriptionAction = styled.button`
  color: #25567c;
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
`;
